export default __webpack_public_path__ + "static/media/message.27f97957.svg";